module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2r"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "ill"
    }
  }), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/f0vii-01.jpg"
    }
  }), _c('span', {
    staticClass: "spacef"
  }, [_c('strong', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ill1"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNESSEE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNTERS AND")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHERERS, CA")]), _vm._v(". 5,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ill2"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OQUA, A")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REHISTORIC")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWN")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("CA")]), _vm._v(". 1450 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D")]), _vm._v(".)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ill3"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEROKEE DELEGATION TO")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(", 1730")])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ill4"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORT")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUDOUN")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ill5"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEROKEE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELEGATION TO")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(", 1762")])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ill6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMBERLAND")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AP")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ill7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERTSON")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ill8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHERING OF THE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERMOUNTAIN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YCAMORE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOALS")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPTEMBER")]), _vm._v(" 1780")])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ill9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOUNT")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ill10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOUNT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANSION AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XECUTIVE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFICE, IN TODAY")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOXVILLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ill11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RONTIER")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUGH AND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMBLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ill12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIER")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ill13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOUNT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLEGE IN")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOXVILLE, CA")]), _vm._v(". 1807")])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ill14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDREW")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ill15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROCKETT")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ill16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EQUOYAH AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEROKEE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YLLABARY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ill17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSS")]), _vm._v(", P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINCIPAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIEF OF THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEROKEE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ill18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAIL OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARS")]), _vm._v("”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670429a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ill.vue
// module id = 75
// module chunks = 0